module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required,
      "size": _vm.size
    }
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": _vm.alpha,
      "placeholder": _vm.placeholder,
      "predefine": _vm.predefineColors,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71065866"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/ColorPicker.vue
// module id = 1547
// module chunks = 0